__turbopack_context__.v({
  "body": "_1mggsW_body",
  "header": "_1mggsW_header",
  "item": "_1mggsW_item",
  "row": "_1mggsW_row",
  "row_1": "_1mggsW_row_1",
  "row_2": "_1mggsW_row_2",
  "row_3": "_1mggsW_row_3",
  "row_4": "_1mggsW_row_4",
});
